export default {
  Welcome: "Welcome",
  InitialEventDetails: "InitialEventDetails",
  GuestsAndLayout: "GuestsAndLayout",
  StylesAndCatering: "StylesAndCatering",
  BudgetAndCorpOrPrivate: "CorpOrPrivate",
  UserDetails: "UserDetails",
  ThankYou: "ThankYou",
};
